/**
 * Resolves payroll i18n keys with English fallbacks when DB strings are not loaded yet.
 */
const PAYROLL_LABEL_FALLBACKS: Record<string, string> = {
  'payroll.deduction_type_late': 'Late',
  'payroll.calculation_method_tiered': 'Tiered',
  'payroll.calculation_method_fixed': 'Fixed',
  'payroll.percentage_base_pay_grades': 'Pay grades',
  'payroll.late_deduction_schedule': 'Late deduction schedule',
  'payroll.late_grace_minutes': 'Grace period (minutes)',
  'payroll.late_half_day_minutes': 'Half-day threshold (minutes late)',
  'payroll.late_from_minutes': 'From (mins)',
  'payroll.late_to_minutes': 'To (mins)',
  'payroll.late_band_rate': 'Rate (%)',
  'payroll.late_band_amount': 'Amount',
  'payroll.late_pay_grades': 'Pay grades (late base)',
  'payroll.late_pay_grade_nominal_source': 'Pay grade nominal',
  'payroll.late_pay_grade_nominal_configured':
    'Configured amount (pay grade setup)',
  'payroll.late_pay_grade_nominal_calculated':
    'Final calculation amount (payroll period)',
  'payroll.net_amount': 'Take Home Pay',
};

type TranslateFn = (key: string) => string;

export function payrollT(t: TranslateFn, key: string): string {
  const translated = t(key);
  if (translated !== key) {
    return translated;
  }
  return PAYROLL_LABEL_FALLBACKS[key] ?? key;
}
